"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiFetch = void 0;
const apiFetch = (resource, init) => {
    const options = Object.assign({ mode: 'cors' }, init);
    return fetch(resource, options);
};
exports.apiFetch = apiFetch;
